import * as React from "react";
import { CampaignEmailApiModel } from "../apiModels/CampaignEmailApiModel";
import * as Noty from "noty";
import { ErrorModal } from "./ErrorModal";
import { HttpErrorHelper } from "../helpers/HttpErrorHelper";
import { RioLoadingIndicator, RioIf, RioAutoCompleteResult, RioInput, RioValidator, RioResources, RioIconButton, RioApiPost, RioApiGet, RioExpandingPanel, RioModal, RioConfirmModal, IRioModelErrors, RioForEach } from "rio.react.all";
import { AutoComplete } from "../components/AutoComplete";
import { LandingWineCampaignApiModel } from "../apiModels/LandingWineCampaignApiModel";
import { LandingWinesManualSendApiModel } from "../apiModels/LandingWinesManualSendViewModel";


interface ILandingWineManualSendTestModalProps {
	selectedCampaigns: Array<LandingWineCampaignApiModel>;
	onClose: () => void;
}

interface ILandingWineManualSendTestModalState {
	toAddress: string;
	responseError: string;
	sending: boolean;
	sendClicked: boolean;
	errorMessages: Array<string>;
}

export class LandingWineManualSendTestModal extends React.Component<ILandingWineManualSendTestModalProps, ILandingWineManualSendTestModalState> {
	constructor(props: Readonly<ILandingWineManualSendTestModalProps>) {
		super(props);

		this.state = {
			toAddress: "",
			responseError: null,
			sending: false,
			sendClicked: false,
			errorMessages: []
		}
	}

	private validator = new RioValidator();

	render() {
		return (
			<React.Fragment>
				<RioModal visible={true} onCancel={() => this.handleCancelClicked()} backgroundClickDisabled={true}>
					<RioExpandingPanel resource={RioResources.find("SendTestEmail")} className="sendTestEmailPanel" expandedDefault={true} disableToggle={true}>
						<div>
							<RioIf condition={this.state.errorMessages != null && this.state.errorMessages.length > 0} then={
								<div className="validationSummary">
									<RioForEach items={this.state.errorMessages} perform={(error, index) => {
										return <div key={`${index}`} className="fieldValidationError">{error}</div>;
									}} />
								</div>

							} />
							<div>
								<div className="form-row">
									<label className="emailTitleLabel">{RioResources.find("EmailAddress").text}<span className="required">*</span></label>
									<RioInput name="toAddress" type="text" className="emailTitleInput" value={this.state.toAddress} onChange={(e) => this.setState({ toAddress: e.target.value })} validator={this.validator} validations={{ required: true }} />
								</div>
							</div>
							<RioIf condition={this.state.sending} then={
								<div>
									<div className="form-row">
										<RioLoadingIndicator />
									</div>
								</div>
							} />
						</div>

					</RioExpandingPanel>

					<div className="buttons emailComposerButtons">
						<RioIconButton resource={RioResources.find("Send")} onClick={() => this.handleSendClicked()} hasPermission={true} />
						<RioIconButton resource={RioResources.find("Cancel")} onClick={() => this.handleCancelClicked()} hasPermission={true} />
					</div>

					<RioIf condition={!!this.state.responseError} then={
						<ErrorModal text={this.state.responseError} onErrorModalClosed={() => this.setState({ responseError: null })} />
					} />

					<RioIf condition={!!this.state.sendClicked} then={
						<RioConfirmModal text={RioResources.find("TestRunClickedConfirmMsg")} onConfirmModalClosed={(result) => this.confirmSendClicked(result)} className="confirmModal" />
					} />

				</RioModal>

			</React.Fragment>
		);
	}

	componentDidMount(): void {
		
	}

	handleCancelClicked() {
		this.props.onClose();
	}

	handleSendClicked() {
		if (!!(this.state.toAddress ?? "").trim()) {
			this.setState({
				sendClicked: true
			})
		}
	}

	confirmSendClicked(result: boolean) {
		if (result) {
			this.setState({
				sending: true
			});

			let vm = new LandingWinesManualSendApiModel;
			vm.testRun = true;
			vm.campaigns = this.props.selectedCampaigns;
			vm.testRunOverrideEmailAddress = this.state.toAddress;

			RioApiPost.asPromise("/api/LandingWineCampaign/Send/", vm)
				.then((response) => {
					this.props.onClose();
				})
				.catch((response) => {
					if (response?.errors != null) {
						this.appendErrorMessages(response.errors);
					} else {
						let error: IRioModelErrors = {
							ValidationSummary: [RioResources.find("UnexpectedErrorMsg").text]
						}

						this.appendErrorMessages(error);
					}
					this.setState({
						sending: false
					})
				});
		}

		this.setState({
			sendClicked: false
		})
	}

	appendErrorMessages(errors: IRioModelErrors) {
		let errorMessages: Array<string> = []; //ValidationSummary is currently broken, so use this as a quick workaround
		for (var key in errors["ValidationSummary"]) {
			errorMessages.push(errors["ValidationSummary"][key]);
		}

		this.setState({
			errorMessages: errorMessages
		});
	}
}
